import {
  ThreeByOneUnit,
  ThreeByOneUnitProps,
} from 'components/ThreeByOneWidget';
import { omitUndefined } from 'utils/collections';
import Player, { PlayerProps } from '../Player';

type BaseUnitProps = Omit<ThreeByOneUnitProps, 'id'>;
const BaseUnit = ThreeByOneUnit as React.FC<BaseUnitProps>;

export interface UnitProps extends PlayerProps, BaseUnitProps {}

const Unit: React.FC<UnitProps> = ({
  artworkAspectRatio,
  artworkResizeStrategy,
  controls,
  controlsSize,
  visualization,
  ...props
}) => (
  <BaseUnit
    player={
      <Player
        {...omitUndefined({
          artworkAspectRatio,
          artworkResizeStrategy,
          controls,
          controlsSize,
          visualization,
        })}
      />
    }
    {...props}
  />
);

export default Unit;
